import { useEffect, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useNotification } from '../../../shared/contexts/NotificationContext'
import { usePlatformAuth } from '../context/PlatformAuthContext'

/**
 * Protege uma rota do painel por permissão fina. Sem a permissão, avisa e
 * reencaminha para a home do painel (`/tenants`, sempre acessível a qualquer
 * admin activo) — nunca para o login. Usar dentro de `PlatformPrivateRoute`,
 * onde `admin` já está resolvido.
 */
export default function RequirePerm({ perm, children }: { perm: string; children: ReactNode }) {
    const { hasPerm } = usePlatformAuth()
    const { notify } = useNotification()
    const permitido = hasPerm(perm)

    useEffect(() => {
        if (!permitido) notify('Não tem permissão para aceder a essa área.', 'warning')
    }, [permitido, notify])

    return permitido ? <>{children}</> : <Navigate to="/tenants" replace />
}
